<template>
  <div class="live-area">
    <div class="live-list-title" :class="{ line: config.topLine }">
      <h3 class="list-title-txt" :class="{ bold: config.bold }">
        {{ config.title }}
      </h3>
      <div class="list-more" v-if="config.more">
        <div class="list-more-txt">{{ config.more.title }}</div>
        <a-icon type="right" />
      </div>
    </div>
    <ul class="live-list">
      <li
        class="live-item"
        :style="contentStyle"
        v-for="(l, i) in config.list"
        :key="i"
      >
        <div
          class="live-cover"
          :style="{
            height: config.height + 'px',
            borderRadius: config.borderRadius + 'px',
            backgroundImage: `url(${l.cover})`,
          }"
        ></div>
        <div class="live-txt">
          <div class="live-txt-left">
            <h3 class="live-title">{{ l.title }}</h3>
            <!-- <div class="live-time">直播时间：{{getShowTime(l.start, l.end)}}</div> -->
            <div class="live-time">{{l.type == 1 ? "直播状态" : "观看视频"}}</div>
          </div>
          <div class="live-txt-right">
            <a-button>{{l.type == 1 ? "进入直播" : "观看视频"}}</a-button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getDistance } from "../../common/js/tool";

export default {
  name: "live-list",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    contentStyle() {
      let content = this.config.content;
      let style = {};
      if (content?.padding) {
        style.padding = getDistance(content.padding);
      }
      if (content?.borderRadius) {
        style.borderRadius = content.borderRadius + "px";
      }
      if (content?.backgroundColor) {
        style.backgroundColor = content.backgroundColor;
      }
      return style;
    },
  },
  methods: {
    getShowTime(start, end) {
      return start && end ? start + " 至 " + end : "";
    },
  },
};
</script>

<style scoped lang="less">
.live-area {
  --border-color: #dcdfe6;
  --border: 1px solid var(--border-color);
  --light-font-color: #c0c4cc;
  --tip-font-color: #909399;
  --back-light-color: #eee;
}
.live-list-title {
  display: flex;
  align-items: center;
  &.line {
    border-bottom: var(--border);
  }
}
.list-title-txt {
  margin: 0;
  flex: 1;
  height: 36px;
  line-height: 36px;
  &.bold {
    font-weight: 600;
  }
}
.list-more {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: var(--light-font-color);
}
.live-list {
  padding: 10px 0;
}
.live-item {
  &:not(:last-of-type) {
    margin-bottom: 12px;
  }
}
.live-cover {
  height: 200px;
  // background: var(--back-light-color) center no-repeat;
  background: center no-repeat;
  background-size: cover;
}
.live-txt {
  flex: 1;
  margin-top: 6px;
  font-size: 12px;
  color: var(--title-font-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.live-title {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
}
.live-time {
  margin-top: 10px;
  color: var(--tip-font-color);
  line-height: 1.2;
}
</style>
